module.exports = __webpack_public_path__ + "img/pronographic.0c51101b.png";